import { render, staticRenderFns } from "./ListAnnotations.vue?vue&type=template&id=5a8f20bd&scoped=true"
import script from "./ListAnnotations.vue?vue&type=script&lang=js"
export * from "./ListAnnotations.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotations.vue?vue&type=style&index=0&id=5a8f20bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f20bd",
  null
  
)

export default component.exports